import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    loading: false,
    appointments: [],
    aptStatus: [],
    aptList: [],
    appointmentlist: [],
    error: "",
    count: 0,
    currentAppointment: null,
    currentCallType: null,
}

const appointmentSlice = createSlice({
    name: "appointments",
    initialState,
    reducers: {
        updateAptStatus: (state, action) => {
            state.aptStatus = action.payload
        },
        updateAppointmentsLoading: (state, action) => {
            state.loading = action.payload
        },
        updateAppointmentList: (state, action) => {
            state.appointments = action.payload
        },
        showAppointmentListing: (state, action) => {
            state.appointmentlist = action.payload
        },
        updateCurrentAppointment: (state, action) => {
            state.currentAppointment = action.payload
        },
        updateCurrentCallType: (state, action) => {
            state.callType = action.payload
        },
    },
})

export const {
    updateAptStatus,
    updateAppointmentList,
    updateAppointmentsLoading,
    showAppointmentListing,
    updateCurrentAppointment,
    updateCurrentCallType
} = appointmentSlice.actions

export default appointmentSlice.reducer
